import { getStore } from '../store/store';
import { FetchState } from '../store/schema';

export function isTeamsPoliciesFetchNotStarted(): boolean {
    const { fetchState } = getStore();

    return fetchState === FetchState.NotStarted;
}
